import React, { useMemo, useRef, useEffect, useState } from 'react'
import { HashRouter as Router, Switch, Route, Link } from 'react-router-dom'
import './index.less'
import Header from '../components/header'
import Foot from '../components/foot'
import Square from '../square'
import Aspirations from '../aspirations'
import Emperor from '../emperor'
import Edit from '../edit'
import ArticleDetail from '../detail'
import Register from '../register'
import Login from '../login'
import Search from '../search'
import Personal from '../personal'

import { Layout } from 'antd'
import { NUser, EPostLogin, EGuestLogin } from '../../models/constants'

import { effect, useStore } from '../../dva16'

const allPages = [
  ['/', Square],
  ['/aspirations', Aspirations],
  ['/emperor', Emperor],
  ['/edit/:categoryID', Edit],
  ['/detail/:id', ArticleDetail],
  ['/register/:type', Register],
  ['/login', Login],
  ['/search/:keyWord', Search],
  ['/personal', Personal],
]


const { Content } = Layout

function Main() {

  useMemo(() => {
    let token = localStorage.getItem('k3Token')
    if (!token) {
      effect(NUser, EGuestLogin)
    }
  }, [])

  return (
    <div id="Main">
      <Layout>
        <Header />
        <Content>
          <Switch>
            {allPages.map(([path, Component], index) => (
              <Route key={index} exact path={path} component={Component} />
            ))}
          </Switch>
        </Content>
        <Foot />
      </Layout>
    </div>
  )
}

export default Main
